import React from 'react'

function AboutMeContent() {
    const font = '"Terminal ", monospace'
    return (
    
    <div id={'about-me-content'} style= {{
        display: 'flex',
        flexFlow: 'column',
        marginLeft: '20%',
        marginRight: '20%',
        overflowX: 'hidden',
        fontFamily: font,
    }}>
        <h1 style={{
            
        }}>
            About Me
        </h1>
        <div style={{
            display: 'flex',
            flexFlow: 'row',
            width:'100%',
        }}>
            <img src={require('../img/bcs_meow.png')} style={{
                margin: 'auto',
                width: '40%',
                height: '100%',
                verticalAlign: 'center',
            }}></img>
            <div>
            <h2 style={{
            textAlign: 'right',
            }}>
                🙋‍♂️ Dan Villa
            </h2>
            <h2 style={{
                textAlign: 'right',
            }}>
                📍 Toronto, Canada
            </h2>
            <h2 style={{
                textAlign: 'right',
            }}>
                🕴️⛔ Not a Lawyer
            </h2>
            <h2 style={{
                textAlign: 'right',
            }}>
                😾 Not a Cat
            </h2>
            </div>
        </div>
        <br/>
        <p>
            Hello! I'm a Computer Engineering student at York University. I am passionate about technology from Digital to Analog. I like to make projects on my spare time, be it from IoT/Digital Device projects that includes microcontrollers and FPGAs to websites like this one!
        </p>
        <p>
            I am currently interning at Intel as a Digital Design Engineer.
        </p>

        <p>
            
        </p>
    </div>
  )
}

export default AboutMeContent